// latest: zhangmyh 2017-11-1 4:35 PM
module.exports = {
  // 登录
  login: {
    type: 'get',
    method: 'get',
    url: '/workbench/sso/login.jsp'
  },
  // 写入用户localStorge
  ebvplogin: {
    type: 'get',
    method: 'get',
    url: '/yuncai/ebvplogin'
  },
  // 档案相关
  doc_supview: {
    type: 'get',
    method: 'get',
    url: '/yuncai/supplydoc/getDocBySupEntId'
  },
  doc_purview: {
    type: 'get',
    method: 'get',
    url: '/yuncai/supplydoc/getDocById'
  },
  doc_getMtrcInfo: {
    type: 'get',
    method: 'get',
    url: '/yuncai/supplydoc/getCategoryDetailByMId'
  },
  // 申请单相关
  apply_getList: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/supplyApply/supplyApply/pageQueryByCondition'
  },
  apply_getState: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/supplyApply/supplyApply/getSupplyApplyStatusAndPercent'
  },
  apply_supview: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/supplyApply/supplyApply/selectSupplyApplyById'
  },
  apply_purview: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/supplyApply/supplyApply/selectSupplyApplyByIdFromPur'
  },
  apply_getMtrcInfo: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/supplyApplySonsService/select/SupplyApplySonsCriteria'
  },
  apply_removeMtrClass: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/supplyApplySonsService/removeCategoryDetailByMClsId'
  },
  apply_saveAndSubmit: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/supplyApply/supplyApply/saveAndCommit'
  },
  apply_approve: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/supplyApply/supplyApply/approve'
  },
  apply_reject: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/supplyApply/supplyApply/reject'
  },
  apply_withdraw: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/supplyApply/supplyApply/cancel'
  },
  apply_own: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/supplyApply/supplyApply/own'
  },
  apply_unown: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/supplyApply/supplyApply/unown'
  },
  // 变更单相关
  edit_getList: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/supplyChange/pageQueryByCondition'
  },
  edit_getListCount: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/supplyChange/selectCountByStatus'
  },
  edit_getOrigin: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/supplyChange/selectEditSupplyChange'
  },
  edit_certOrigin: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/supplyChange/certChange'
  },
  edit_getData: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/supplyChange/supply/selectSupplyChangeById'
  },
  edit_agGetData: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/supplyChange/purchase/selectSupplyChangeById'
  },
  edit_save: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/supplyChange/saveSupplyChange'
  },
  edit_saveAndSubmit: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/supplyChange/saveAndCommit'
  },
  edit_saveMtrClass: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/supplyChangeDetail/saveCategory'
  },
  edit_getMtrcInfo: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/supplyChangeDetail/getCategoryDetail'
  },
  edit_getMtrcList: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/supplyChangeDetail/pageQueryExistCategorys'
  },
  edit_removeMtrClass: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/supplyChangeDetail/removeCategoryChangeDetailByMClsId'
  },
  edit_submit: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/supplyChange/commit'
  },
  edit_approve: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/supplyChange/approve'
  },
  edit_reject: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/supplyChange/reject'
  },
  edit_withdraw: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/supplyChange/cancel'
  },
  edit_own: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/supplyChange/own'
  },
  edit_unown: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/supplyChange/unown'
  },
  // 地址相关
  address_province: {
    type: 'get',
    method: 'get',
    url: '/yuncai/address/getProvincedata'
  },
  address_city: {
    type: 'get',
    method: 'get',
    url: '/yuncai/address/getCitydata'
  },
  address_district: {
    type: 'get',
    method: 'get',
    url: '/yuncai/address/getDistrictdata'
  },
  // 机构类型
  company_category: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/supplyMgrBaseDoc/companyCategory/select'
  },
  // 注册相关
  reg_getGraphVali: {
    type: 'get',
    method: 'get',
    url: '/yuncai/supplyregister/images/getValiImage'
  },
  reg_checkphone: {
    type: 'get',
    method: 'get',
    url: '/yuncai/supplyregister/isTelExist'
  },
  reg_checklicence: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/out/supplymgr/checkRepeatBusLicenceNum'
  },
  reg_checkidentNum: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/out/supplymgr/checkRepeatCertNum'
  },
  reg_checksupplyname: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/out/supplymgr/checkRepeatEnterPriseName'
  },
  reg_sendMsg: {
    type: 'get',
    method: 'get',
    url: '/yuncai/supplyregister/sendPhoneMsg'
  },
  reg_register: {
    type: 'set',
    method: 'post',
    url: '/yuncai/supplyregister/register'
  },
  proxy_register: { // 代理注册接口
  type: 'set',
  method: 'post',
  url: '/yuncai/proxyregister/proxy_register'
  },
  // 资质相关
  qf_class: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/qualify/qualifyTypes'
  },
  qf_basicqf: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/qualify/qualify/pageQueryQualifyByConditions'
  },
  qf_expdate: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/supplyApply/supplyApply/countExpDateQualifys'
  },
  qf_delete: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/qualify/deleteQualifyType'
  },
  // 物料分类相关
  mc_getclass: {
    type: 'get',
    method: 'get',
    url: '/yuncai/materialClass/getClassByParentId'
  },
//新物料分类相关
  mc_getclass1: {
    type: 'get',
    method: 'get',
    url: '/yuncai/materialClass/getClassByParentIdKeyword'
  },
  // 销售分类相关
  sc_getclass: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/saleClass/getClassByParentId'
  },
  // 基础数据
  // 租户信息
  get_enterpriseInfo: {
    type: 'get',
    method: 'get',
    url: '/cpu-basedocrefer/enterprise/getById'
  },
  // 获取问题列表
  get_qanda: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/question/questions'
  },
  // 币种
  get_currency: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/enum/enums?contentType=currency'
  },
  // 计量单位
  get_unit: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/measure/measureUnits'
  },
  // 指标表
  nm_addNorm: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/supplyMgrBaseDoc/indicator/add'
  },
  // 评分表管理
  ea_removeEa: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/evaluateApply/deleteByIds'
  },
  // 根据模板分类id查询对应的模板信息(适用 3 4 5 6 )
  getTplByClassId: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/templet/TempsPageToAssign'
  },
  // 根据模板分类id查询对应的模板信息(适用 2 )
  getQualifyTplByClassId: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/checkTemplet/getQualifyCheckTempletByCond'
  },
  // 资质模版
  cert_getClassList: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/certificationClass/selectCertificationClassByCondition'
  },
  cert_addClass: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/certificationClass/insertCertificationClass'
  },
  cert_editClass: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/certificationClass/updateCertificationClass'
  },
  cert_delClass: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/certificationClass/deleteCertificationClass'
  },
  cert_ignore: {
    type: 'set',
    method: 'get',
    url: '/cpu-supplymgr/certfill/ignore'
  },
  cert_submit: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/certificationApply/submitCertification'
  },
  // 供应商分级认证管理
  ag_hierarchicalLsit: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/certificationApply/pageQuery'
  },
  // 资质审核模版查看
  qlftpl_getData: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/checkTemplet/getQualifyCheckTempletById'
  },
  // 资质审核模版编辑
  qlftpl_getDataEdit: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/checkTemplet/getById'
  },
  qlftpl_saveData: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/checkTemplet/add'
  },
  qlftpl_saveEdition: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/checkTemplet/addTemplet'
  },
  qlftpl_setStatus: {
    type: 'set',
    method: 'get',
    url: '/cpu-supplymgr/checkTemplet/updateCheckStatusById'
  },
  qlftpl_setConfig: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/certFillApply/selectCertFillApplyById'
  },
  // 等级体系
  certsys_getData: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/supplyMgrBaseDoc/abilityDetial/select'
  },
  // 人员参照左树点击事件
  ea_getDept: {
    type: 'get',
    method: 'get',
    url: '/cpu-basedocrefer/basedocrefer/orgdept/getorgbyparentid'
  },
  // 认证审核分页查询
  cerapprovalList: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/certificationApply/pageQueryCOMMITED'
  },
  // 认证 等级分配查询
  certStepList: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/certStep/selectByCondition'
  },
  // 认证 切换等级分配查询
  getAbilityDetails: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/certStep/getAbilityDetails'
  },
  // 认证 切换等级保存
  saveCertStep: {
    type: 'set',
    method: 'post',
    url: '/cpu-supplymgr/certStep/save'
  },
  // 驳回
  rej_getType: {
    type: 'get',
    method: 'get',
    url: '/cpu-supplymgr/rejectCommon/getAllRejectCommonType'
  }
}



// WEBPACK FOOTER //
// ./src/common/URLs.js